import Axios from "../utils/http-request";

export const apiGetAccountType = async () => {
  try {
    const uri = `/account-types`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};
export const apiGetPosition = async () => {
  try {
    const uri = `/positions`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};
export const apiGetParties = async () => {
  try {
    const uri = `/parties`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};
export const apiGetState = async () => {
  try {
    const uri = `/states`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};
export const apiGetLocalGovernment = async (state_id: string) => {
  try {
    const uri = `/local-governments/${state_id}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};
export const apiGetConstituencies = async (lga_id: string) => {
  try {
    const uri = `/constituencies/${lga_id}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};
export const apiGetDistricts = async (lga_id: string) => {
    try {
      const uri = `/districts/${lga_id}`;
  
      // Get request configuration (assuming this function provides headers, etc.)
      const cfg = {
        headers: {
          "Content-Type": "application/json",
        },
      };
  
      // Send the GET request
      const result = await Axios.get(uri, cfg);
  
      // Return the result
      return result;
    } catch (e: any) {
      console.error(e);
  
      // Return error response
      return {
        data: {},
        status: "error",
        details: e?.response?.data?.details || e?.details,
      };
    }
  };


  